import React from 'react';
import MuiPagination from '@mui/material/Pagination';
import MuiPaginationItem from '@mui/material/PaginationItem';

type AppPaginationProps = {
  page: number;
  totalItems: number;
  onChange: (page: number) => void;
  pageSize?: number;
  siblingCount?: number;
  boundaryCount?: number;
  color?: 'primary' | 'secondary' | 'standard';
  shape?: 'rounded' | 'circular';
  muiSize?: 'small' | 'medium' | 'large';
  hideIfSinglePage?: boolean;
  className?: string;
};

export const AppPagination: React.FC<AppPaginationProps> = ({
  page,
  totalItems,
  onChange,
  pageSize = 5,
  siblingCount = 1,
  boundaryCount = 1,
  color = 'primary',
  shape = 'rounded',
  muiSize = 'medium',
  hideIfSinglePage = true,
  className,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

  if (hideIfSinglePage && totalPages <= 1) return null;

  return (
    <div className={`flex justify-end ${className ?? ''}`}>
      <MuiPagination
        count={totalPages}
        page={page}
        onChange={(_e, val) => onChange(val)}
        color={color}
        shape={shape}
        siblingCount={siblingCount}
        boundaryCount={boundaryCount}
        size={muiSize}
        renderItem={(item) => (
          <MuiPaginationItem
            {...item}
            sx={{
              '&.Mui-selected': {
                bgcolor: '#2563eb',
                color: '#ffffff',
              },
              '&.Mui-selected:hover': {
                bgcolor: '#2563eb',
              },
            }}
          />
        )}
      />
    </div>
  );
};